export default "__VITE_ASSET__BAgEWe1T__"